/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import Spinner from 'common/Spinner';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import fieldActions from 'core/fields/actions';

const styles = ({ palette }) => ({
  error: {
    color: palette.error,
  },
  spinner: {
    '& > .spinner': {
      position: 'relative !important',
    },
    display: 'block',
    margin: [0, 'auto'],
    position: 'relative',
    textAlign: 'center',
  },
});

const MobileFlow = ({ classes }) => {
  // useSelectors
  const {
    configs: { socureApiKey },
    page,
    resources: { socureErrorMsg: errorMsg },
  } = useSelector((state) => state, shallowEqual);

  // useDispatch
  const dispatch = useDispatch();

  // useStates
  const [error, setError] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const runSocure = () => {
    window.SocureInitializer.init(socureApiKey).then((lib) => {
      lib
        .init(socureApiKey, '#socureEmbedId', {
          onError: (resp) => {
            fieldActions.socureAutocomplete(resp);
            setError(true);
          },
        })
        .then(() => {
          lib
            .start(
              2,
              {},
              {
                dataMandatory: false,
                redirect: {
                  method: 'GET',
                  url: `${window.location.origin}/oao/${page.name}`,
                },
                sendMessage: true,
              },
            )
            .then((response) => {
              lib.cleanup();
              lib.unmount();
              dispatch(fieldActions.socureAutocomplete(response));
              setShowSpinner(false);
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.log(JSON.stringify(err));
              setError(true);
            });
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(err));
          setError(true);
        })
        .finally(() => {
          lib.reset();
        });
    });
  };

  // useEffects
  useEffect(() => {
    setShowSpinner(true);
    runSocure();
    // dispatch(fieldActions.socureRetrieveInformation(referenceId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!showSpinner) {
    return <></>;
  }

  if (error) {
    return <p className={classes.error}>{errorMsg}</p>;
  }

  return (
    <>
      <div id="socureEmbedId" className="hidden" />
      <div className={classes.spinner}>
        <Spinner loading type="page" />
      </div>
    </>
  );
};

export default withStyles(styles)(MobileFlow);
